"use client";

import * as React from "react";
import { cn } from "@/lib/utils";

export const HeaderRail = React.forwardRef<HTMLDivElement, React.ComponentProps<"div">>(({ className, ...props }, ref) => {
  return <div ref={ref} className={cn("absolute inset-x-0 -bottom-4 h-5 pointer-events-none ", className)} {...props} />;
});
HeaderRail.displayName = "HeaderRail";
